<template>
  <d-button-group class="buttons">
    <d-button size="sm" class="btn-info" @click.prevent="edit()">
      <i class="fas fa-pencil-alt mr-1" />
      <span class="d-none d-lg-inline">Editar</span>
    </d-button>
    <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
      <i class="fas fa-trash mr-1" />
      <span class="d-none d-lg-inline">Deletar</span>
    </d-button>
  </d-button-group>
</template>

<script>
import Events from '_utils/events';
import { _DELETE_MANAGER_ } from './ManagerModel';

export default {
  name: 'manager-buttons',
  props: {
    manager: {
      type: Object,
      default: null,
    },
  },
  methods: {
    edit() {
      this.$router.push(`/admin/gerentes/${this.manager.id}`);
    },
    confirmDeleteRow() {
      Events.$emit(_DELETE_MANAGER_, this.manager);
    },
  },
};
</script>
